
export const getEntries = state => state.entries;

export const getSearch = state => state.search;

export const getLoadingEntries = state => state.loadingEntries;

export const getSelectedEntry = state => state.selectedEntry;

export const getLoadingSelectedEntry = state => state.loadingSelectedEntry;

export const getFilters = state => state.filters;

export const getSettings = state => state.settings;

export const toggleSearch = state => state.toggle;
